import script from "./UserConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./UserConfig.vue?vue&type=script&setup=true&lang=js"

import "./UserConfig.vue?vue&type=style&index=0&id=3636559c&scpoed=true&lang=css"

const __exports__ = script;

export default __exports__